import { Grid, Card, CardContent, Box, Typography, Button } from "@mui/material"
import { RectangularSkeleton } from "../../_helpers/reusablefunctions/SkeletonCard"

export const StatsCards = ({ data, loading }) => {
  const stats = [
    // { label: "Music distribution", value: "Studio", key: null },
    { label: "Total Links", value: data?.link_count || '0', key: "link_count" },
    { label: "Total Playlist", value: data?.playlist_count || '0', key: "playlist_count" },
    { label: "Total Song", value: data?.song_count || '0', key: "song_count" },
  ]

  if (loading) {
    return (
      RectangularSkeleton()
    )
  }

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card variant="outlined" sx={{ border: '1px solid rgba(0, 0, 0, 0.12)', boxShadow: 'none', backgroundColor: "#FFFFFF", borderRadius: "20px", height: "96px" }}>
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="h4" fontWeight="bold">
                      {stat.prefix || ""}
                      {stat.value || ""}
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.8 }}>
                      {stat.label}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}

      </Grid>


      <Card
        sx={{
          p: { xs: 2, md: 2 },
          background: 'linear-gradient(to right, #111827, #1e3a8a)',
          color: 'white',
          mt: 4,
          borderRadius: '10px',
          gap: { xs: '5px', md: "10px" },
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          alignItems: { xs: 'left', md: 'center' },
          justifyContent: { xs: "none", sm: 'none', md: 'space-between' },
        }}
      >
        <Box sx={{ paddingLeft: { xs: '0px', md: '20px' } }}>
          <Typography fontWeight={700} sx={{ fontSize: { xs: '16px', sm: '22px', md: '25px' }, maxWidth: { xs: '100%', }, textAlign: 'left' }}>
            Create. Click. Conquer. <br /> Get your song live on all major platforms
          </Typography>
        </Box>
        <Box>
          <a target="_blank" href="https://studio.gntunes.com/" ><Button className="gn-actionbtn" variant="contained" sx={{ fontSize: '14px !important' }} size="small" >Music distribution</Button></a>
        </Box>
      </Card>
    </>
  )
}
